// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import { Document, Security } from '@carbon/icons-react';
import { CreateProcedureCard } from '../components/CreateProcedureCard/';

import styles from './AddProcedurePage.module.css';
import { useNavigate } from 'react-router-dom';

/**
 * Procedures > Add procedure. Both "start a blank" buttons navigate to their
 * respective create screens (`procedures/new`, `procedures/new-policy`).
 * The upload dropzones are still layout only — no upload, no draft creation
 * from a document (see admin-center/README.md).
 */
export default function AddProcedurePage() {
  const navigate = useNavigate();

  return (
    <div>
      <div className={styles.title}>New</div>

      <div className={styles.grid}>
        <CreateProcedureCard
          icon={Document}
          label="Procedure"
          helperText="Drop a PDF, Word, Excel or PPT here, or click to browse. Steps are extracted into a draft."
          buttonLabel="Start a blank procedure"
          onActionClick={() => {
            navigate('/admin-center/procedures/new');
          }}
        />
        <CreateProcedureCard
          icon={Security}
          iconClassName={styles.policyIcon}
          label="Policy"
          helperText="Drop a PDF, Word, Excel or PPT here, or click to browse. Clauses are extracted into a draft."
          buttonLabel="Start a blank policy"
          onActionClick={() => {
            navigate('/admin-center/procedures/new-policy');
          }}
        />
      </div>
    </div>
  );
}
